import { CustomButton } from "../../CustomButton";
import { useState } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { ReuseModal } from "../../ReuseModal";
import { campaignsApi, useRemoveAccountPlanMutation } from "../../../../api";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { useNavigate } from "react-router-dom";
import { AppRoutes, PlaybookPlanNames } from "../../../../types/enums";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";

export const RemoveAccountPlanBtn = ({
  companyName,
  account_id,
  campaign_id,
}: {
  companyName: string;
  account_id: string;
  campaign_id: string;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { isAllowedEditGenerateReports } = useAppSelector(selectPermissions);
  const [deleteAccountPlan, { isLoading }] = useRemoveAccountPlanMutation();

  const deleteAccountPlanHandler = () => {
    deleteAccountPlan({ id: account_id, campaign_id })
      .unwrap()
      .then(() => {
        dispatch(campaignsApi.util.invalidateTags(["summary"]));
        navigate(`${AppRoutes.ACCOUNT}/${campaign_id}/${account_id}`);
      })
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title={`Failed Delete ${PlaybookPlanNames.account_plan}`}
          />,
        );
      });
    setIsOpen(false);
  };

  return (
    <>
      <CustomButton
        onClick={() => setIsOpen(true)}
        variant="contained"
        textColor="#FFFFFF"
        customColor="#C0392B"
        type="button"
        customSize={"fit"}
        sx={{ height: "38px" }}
        disabled={isLoading || !isAllowedEditGenerateReports}
        startIcon={
          isLoading && <CircularProgress size={20} sx={{ color: "inherit" }} />
        }
      >
        Remove {PlaybookPlanNames.account_plan}
      </CustomButton>
      <ReuseModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={deleteAccountPlanHandler}
        title={`Remove ${PlaybookPlanNames.account_plan}`}
        customText={
          <Stack gap="32px">
            <Typography variant="body1" color="text.secondary">
              Are you sure you want to remove the{" "}
              {PlaybookPlanNames.account_plan} for {companyName}?
            </Typography>
            <Typography variant="body1" color="text.secondary">
              You’ll need to generate it again if you need it later.
            </Typography>
          </Stack>
        }
        isDisabled={isLoading}
        isLoading={isLoading}
        submitBtnText="Remove"
        maxWidth="440px"
      />
    </>
  );
};
